// extracted by mini-css-extract-plugin
export default {"btn":"homepage_btn__2d1y7"};